import classNames from 'classnames'
import type { FC } from 'react'
import styles from './ExpanderContent.module.scss'
import type { ExpanderChildProps } from './types'

const ExpanderContent: FC<ExpanderChildProps> = ({ children, className }) => {
  return <div className={classNames(styles['pintxo-expander-content'], className)}>{children}</div>
}

export default ExpanderContent
